import { z } from "zod";
// Enum string values use lowercase camelCase to mirror @supernovaio/sdk
// SDKDataset.toRemote() shape — keeps BE schemas 1:1 with the SDK wire format.
export const DATASET_ENTITY_TYPES = [
    "tokens",
    "tokenThemes",
    "figmaComponents",
    "designComponents",
    "assets",
    "documentation",
    "contexts",
    "skills",
    "files",
    "codeComponents",
];
export const DatasetEntityType = z.enum(DATASET_ENTITY_TYPES);
export const DATASET_LOGICAL_OPERATORS = ["and", "or"];
export const DatasetLogicalOperator = z.enum(DATASET_LOGICAL_OPERATORS);
export const DATASET_PROPERTY_OPERATORS = [
    "is",
    "isNot",
    "contains",
    "doesNotContain",
    "startsWith",
    "endsWith",
    "isEmpty",
    "isNotEmpty",
    "greaterThan",
    "greaterThanOrEqual",
    "lessThan",
    "lessThanOrEqual",
    "in",
    "notIn",
];
export const DatasetPropertyOperator = z.enum(DATASET_PROPERTY_OPERATORS);
export const DatasetPrimitiveValue = z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.null(),
]);
export const DatasetConditionValue = z.union([
    DatasetPrimitiveValue,
    z.array(DatasetPrimitiveValue),
]);
export const DatasetIncludeAllCondition = z.object({
    type: z.literal("includeAll"),
});
export const DatasetIncludeIdsCondition = z.object({
    type: z.literal("includeIds"),
    ids: z.array(z.string()),
});
export const DatasetExcludeIdsCondition = z.object({
    type: z.literal("excludeIds"),
    ids: z.array(z.string()),
});
export const DatasetPropertyCondition = z.object({
    type: z.literal("property"),
    property: z.string(),
    operator: DatasetPropertyOperator,
    value: DatasetConditionValue.optional(),
});
export const DatasetCondition = z.discriminatedUnion("type", [
    DatasetIncludeAllCondition,
    DatasetIncludeIdsCondition,
    DatasetExcludeIdsCondition,
    DatasetPropertyCondition,
]);
export const DatasetFilterGroup = z.lazy(() => z.object({
    type: z.literal("group"),
    operator: DatasetLogicalOperator,
    children: z.array(DatasetFilterNode),
}));
export const DatasetFilterNode = z.lazy(() => z.union([DatasetCondition, DatasetFilterGroup]));
export const DatasetSelections = z.object(Object.fromEntries(DATASET_ENTITY_TYPES.map((entityType) => [
    entityType,
    DatasetFilterGroup.optional(),
])));
export const ForgeProjectContextScope = z.object({
    designSystemId: z.string().nullish(),
    selections: DatasetSelections.optional(),
});
// User-editable suffix in `/mcp/c/<id>-<slug>`. Lowercase alphanumeric + hyphens
// only; no leading/trailing or consecutive hyphens.
export const FORGE_PROJECT_CONTEXT_MCP_URL_SLUG_MAX_LENGTH = 64;
const MCP_URL_SLUG_PATTERN = /^[a-z0-9](?:[a-z0-9]|-(?!-))*[a-z0-9]$|^[a-z0-9]$/;
export const ForgeProjectContextMcpUrlSlug = z
    .string()
    .min(1)
    .max(FORGE_PROJECT_CONTEXT_MCP_URL_SLUG_MAX_LENGTH)
    .regex(MCP_URL_SLUG_PATTERN, "mcpUrlSlug must be lowercase alphanumeric with single hyphens.");
